import { type MetaFunction } from '@remix-run/node'
import productLandlords from './product-landlords.png'

export const meta: MetaFunction = () => [
	{ title: 'Insurance for Landlords' },
	{
		name: 'description',
		content: 'We offer insurance for landlords.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">
				Landlord Insurance / Rental Properties
			</h1>
			<img
				src={productLandlords}
				alt="Two residential doors side by side in a multi-family building."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				If you own a home that you don't live in, you probably don't qualify for
				a regular homeowner's policy. If the home is rented to others, you can
				cover your interest in the property by purchasing a landlord policy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				FAQ: Why does a landlord policy have a higher cost than a homeowners
				policy?
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				A homeowner's policy does have a lower premium than a comparable
				landlord policy. The reasons being: Insurer's experience insuring
				landlords has shown that the cost of claims for these dwellings is
				higher per capita than owner-occupied homes. When a homeowner lives in
				the home they are more tuned in to the threats that exist. Many exhibit
				pride of ownership and maintain their home and living area. Those that
				do not own the home they live in may be limited in the actions they are
				able to take during an emergency situation when every second counts.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				A landlord policy has multiple coverage parts:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				1. Building coverage
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				This insures your interest in the building. You may have the option of
				selecting Actual Cash Valuation or Replacement Cost Valuation. The
				replacement cost policy will insure the home for the cost to rebuild the
				home with today's labor and material costs. Actual cash value is
				determined by selecting a certain percentage of the replacement cost or
				some other measure of the property value - such as the purchase price.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				2. Personal property
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Many rental houses or apartments have furnishings such as refrigerator,
				laundry washing machine & dryer, or may even provide a “fully furnished”
				living space. Care should be taken to account for these items so that
				the can be included in an insurance policy where appropriate. The
				personal property owned by the tenant would not be included in the
				landlord's policy, which is why anyone who rents the unit they live in
				should obtain renters insurance to cover their own personal property and
				liability.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				3. Loss of Rental Income
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Many times when significant damage is caused to a building, the
				restoration process can take time. It may mean that the area becomes
				uninhabitable. When this happens some tenants will move to a different
				unit and their rent will go along with them. Since many landlords depend
				on the rents as a source of income, the financial blow of this lost
				income can quickly add up. The loss of rents coverage should be
				sufficient for all repairs to be completed in a reasonable amount of
				time, since it can take up to a year or more for the entire process to
				play out before the unit is ready for occupancy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				4. Liability Coverage & Medical Payments
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The deeded owner is likely to be brought into a lawsuit concerning an
				accident or injury on premises. Coverage for the legal defense and
				payment of the legal liability for the loss is very helpful and desired
				by landlords. In addition the rental/lease agreement between the
				landlord and the tenant is likely to include a provision requiring the
				tenant to carry his or her own liability insurance. Many landlords are
				rightfully leery of renting pet owners because the landlord could be
				dragged into a lawsuit involving an injury caused by a tenant's pet.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				How is my rate determined?
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				One determinant that is used by most insurers when calculating the cost
				of a landlord insurance policy is the number of units. The landlord
				policy can typically accommodate buildings with 1-4 units. If there are
				5 or more units, then a different type of policy may be in order. The
				higher the number of units, the more comings and goings there will be,
				and consequently, a higher liability premium.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Some companies include a discount when the lease agreement requires an
				annual commitment from the tenant and when the tenant maintains their
				own renters insurance.
			</p>
		</main>
	)
}
